// extracted by mini-css-extract-plugin
export default {"items":"Nn58hErXm7GsILtCdIEItw==","logo":"VYWRgJaA8qi-8FM4OZRcwQ=="};